import { gql } from '@apollo/client'

export const GET_USER_ACTIVE_CART_DETAILS = gql`
  query GetUserActiveCartDetails {
    findCart {
      pk
      id
      status
      deliveryOption
      createdAt
      items {
        id
        pk
        artwork {
          id
          slug
          title
          subTitle
          artistFullName
          disablePromocodes

          artworkOrTourOrArtistImage {
            id
            extension
            path
          }
          venue {
            id
            city
            name
            state
            country
            timeZone
          }
          eventStartDateLocal
        }
        package {
          id
          pk
          name
          shortDescription
          longDescription
          deliveryNotes
          price
          image {
            path
            extension
          }
        }
        tevoTicketGroup {
          id
          type
          inHandOn
          format
          row
          section
          retailPrice
          quantity
          availableQuantity
        }
        quantity
        price
      }
    }
  }
`
export const GET_USER_ACTIVE_SHORT_CART = gql`
  query GetUserActiveShortCart {
    findCart {
      pk
      id
    }
  }
`
export const GET_USER_ACTIVE_ARTWORK_PACKAGE_CART = gql`
  query GetUserActiveMediumCart {
    findCart {
      pk
      id
      items {
        id
        quantity
        price
        artwork {
          id
          slug
          title
          subTitle
          artistFullName
          artworkOrTourOrArtistImage {
            id
            extension
            path
          }
          eventStartDateLocal
        }
        package {
          id
          pk
        }
      }
    }
  }
`
